module.exports = __webpack_public_path__ + "img/css.728b90bb.svg";